module.exports = __webpack_public_path__ + "img/desktop_landing_page_banner.4039644c.png";